// extracted by mini-css-extract-plugin
module.exports = {"noScroll":"Index_noScroll__3crMM","wrapper":"Index_wrapper__av-hL","wrapperNoScroll":"Index_wrapperNoScroll__1a61A","content":"Index_content__2cSBn"};